import { ArrowRight, CheckCircle2, Compass, LockKeyhole, Map, MessageSquareText, Target } from 'lucide-react'
import { Link } from 'react-router-dom'
import { openFeedbackDialog } from '../feedback-events.js'
import { useLearningPlan } from '../modules/learning/useLearningPlan.js'

function StudentRoadmapEmpty() {
  return (
    <main className="page-container student-roadmap-page">
      <section className="student-roadmap-empty">
        <span><Map size={18} /> Learning OS</span>
        <h1>先生成学习计划，再开始路线学习</h1>
        <p>路线会把目标拆成阶段，再把每个阶段拆成知识点、练习、资源和项目。</p>
        <Link className="primary-button" to="/onboarding">
          30 秒生成学习计划 <ArrowRight size={16} />
        </Link>
      </section>
    </main>
  )
}

function StudentRoadmapOverviewPage() {
  const {
    completedStageIds,
    error,
    load,
    loading,
    plan,
    roadmap,
    summary,
  } = useLearningPlan()
  const isAiPlan = plan?.source === 'ai_generated' || Number(plan?.schemaVersion) >= 2
  const stepHref = (stage) => {
    const step = stage?.steps?.find((item) => !item.completed) || stage?.steps?.[0]
    if (!step?.id) return '/learning'
    return `${isAiPlan ? '/learning/ai/' : '/learning/'}${encodeURIComponent(step.id)}`
  }

  if (!loading && !error && !plan) return <StudentRoadmapEmpty />

  return (
    <main className="page-container student-roadmap-page learning-os-roadmap-page">
      <section className="student-roadmap-hero">
        <span><Map size={18} /> 学习执行路线</span>
        <h1>{loading ? '正在生成你的路线...' : `${plan?.targetDirection || '成长目标'} 路线地图`}</h1>
        <p>每个阶段都拆成知识点。进入当前阶段后，按视频、文档、小练习、小测试和项目完成今天的学习。</p>
        <div className="student-roadmap-progress">
          <strong>{summary.progress}%</strong>
          <span>{summary.completedCount}/{summary.total || 0} 个阶段完成</span>
        </div>
        {summary.current ? (
          <Link className="primary-button" to={stepHref(summary.current)}>
            继续 {summary.current.name} <ArrowRight size={16} />
          </Link>
        ) : null}
        <Link className="secondary-button" to="/explore">
          <Compass size={16} /> 迷茫？生成 7 天改变计划
        </Link>
      </section>

      {error ? (
        <section className="student-growth-error-state">
          <MessageSquareText size={20} />
          <div>
            <strong>学习路线加载失败</strong>
            <p>{error}</p>
          </div>
          <button type="button" className="secondary-button" onClick={() => load()}>
            重试
          </button>
          <button type="button" className="secondary-button" onClick={() => openFeedbackDialog()}>
            提交反馈
          </button>
        </section>
      ) : null}

      <section className="student-roadmap-map" aria-label="学习阶段路线">
        {loading ? (
          <article className="student-roadmap-stage-card is-current">
            <span><Target size={15} /> 加载中</span>
            <h2>正在读取成长计划</h2>
            <p>如果长时间没有响应，可以回到 Onboarding 重新生成目标。</p>
          </article>
        ) : roadmap.map((stage) => {
          const isDone = completedStageIds.includes(stage.id) || stage.completed
          const isCurrent = summary.current?.id === stage.id
          return (
            <Link
              className={`student-roadmap-stage-card ${isDone ? 'is-done' : ''} ${isCurrent ? 'is-current' : ''} ${stage.locked ? 'is-locked' : ''}`}
              key={stage.id}
              to={stepHref(stage)}
            >
              <span>
                {isDone ? <CheckCircle2 size={15} /> : stage.locked ? <LockKeyhole size={15} /> : <Target size={15} />}
                第 {stage.order} 阶段
              </span>
              <h2>{stage.name}</h2>
              <p>{stage.goal}</p>
              <div className="learning-os-stage-mini">
                <strong>{stage.stepProgress || 0}%</strong>
                <small>{stage.completedSteps || 0}/{stage.steps?.length || 0} 个知识点</small>
              </div>
              <small>{isCurrent ? '当前阶段' : isDone ? '已完成' : stage.locked ? '未解锁' : '可开始'}</small>
            </Link>
          )
        })}
      </section>
    </main>
  )
}

export default StudentRoadmapOverviewPage
